<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div class="wrap-title">
          <label class="label-input">Content</label>
          <div class="mb-5">
            <label class="">Title Content</label>
            <ckeditor :editor="editor" v-model="fields.titleContent" :config="editorConfig" />
          </div>
          <div class="mb-5">
            <div class="">Table Benefits Comparison</div>
            <ckeditor :editor="editor" v-model="fields.tableBenefitsComparison" :config="editorConfig" />
          </div>
          <div class="mb-5">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="border-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.borderColor"
                    @change="handleChangeBorderColor"
                  />
                  <v-text-field v-model="fields.borderColor" label="Border Color" />
                  <v-btn @click="handleResetBorderColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox style="margin-top: 0" v-model="fields.headerBorderEnabled" label="Header Border Enabled" />
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
export default {
  name: 'table-benefits-comparison-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        backgroundColor: '',
        borderColor: '#e5e7eb',
        titleContent: '',
        tableBenefitsComparison: '',
        headerBorderEnabled: false,
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTableBenefitsComparison(
        this.sectionEditor.section.html,
        this.fields,
      );
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields.backgroundColor = '';
    },
    handleChangeHeaderColor(event) {
      this.fields.tableHeaderColor = event.target.value;
    },
    handleResetHeaderColor() {
      this.fields.tableHeaderColor = '';
    },
    handleChangeOddRowColor(event) {
      this.fields.tableOddRowColor = event.target.value;
    },
    handleResetOddRowColor() {
      this.fields.tableOddRowColor = '';
    },
    handleUploadBackgroundImage(obj) {
      this.fields.backgroundImage.image = obj.imageSrc;
      this.fields.backgroundImage.enable = true;
    },
    handleRemoveBackgroundImage() {
      this.fields.backgroundImage.image = '';
      this.fields.backgroundImage.enable = false;
    },
    handleChangeBorderColor(event) {
      this.fields.borderColor = event.target.value;
    },
    handleResetBorderColor() {
      this.fields.borderColor = '#e5e7eb';
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .wrap-title {
  .ck-editor__editable {
    min-height: 150px !important;
  }
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
